// extracted by mini-css-extract-plugin
export default {"QuizLayout":"quizLayout_QuizLayout__NONit","content":"quizLayout_content__bKp9m","time-up-overlay":"quizLayout_time-up-overlay__ucg2r"};